import React from 'react'
import PropTypes from 'prop-types'
import CircleIcon from '@mui/icons-material/Circle'
import { Card, CardContent, Grid, Typography } from '../../../../components/mui/Core/index'
import ChangePasswordModal from '../ChangePasswordModal/change-password-modal'
import Constants from '../../../../constants/en.json'
import SubHeader from '../../../../components/SubHeader/sub-header'

function ChangePasswordCard({ handleSubmitUpdatedPassword }) {
  const cardStyle = {
    minWidth: '496px',
    padding: '0',
    borderRadius: '12px !important',
    boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.3) !important',
    mt: '18px',
    py: 0,
  }

  const cardContentStyle = {
    padding: '10px 25px 18px !important',
  }

  const maskedPasswordStyle = {
    fontSize: '14px',
  }

  const passwordSubHeaderContainerStyle = {
    display: 'flex',
    mt: '3px',
    width: '120px',
  }

  const passwordContainerStyle = {
    display: 'flex',
    justifyContent: 'right',
    mt: '3px',
    flexGrow: 1,
  }

  const changePasswordContainerStyle = {
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '15px !important',
    paddingTop: '10px !important',
    width: '100px',
  }

  return (
    <Card id='password-card' sx={cardStyle}>
      <CardContent sx={cardContentStyle}>
        <SubHeader title={Constants.accountSettings.changePassword.TITLE} />
        <Grid container spacing={1}>
          <Grid sx={passwordSubHeaderContainerStyle}>
            <Typography variant='cardMessage'>
              {Constants.accountSettings.changePassword.PASSWORD_SUBHEADER}:
            </Typography>
          </Grid>
          <Grid sx={passwordContainerStyle}>
            <Typography variant='cardMessage'>
              <CircleIcon sx={maskedPasswordStyle} />
              <CircleIcon sx={maskedPasswordStyle} />
              <CircleIcon sx={maskedPasswordStyle} />
              <CircleIcon sx={maskedPasswordStyle} />
              <CircleIcon sx={maskedPasswordStyle} />
              <CircleIcon sx={maskedPasswordStyle} />
              <CircleIcon sx={maskedPasswordStyle} />
            </Typography>
          </Grid>
          <Grid sx={changePasswordContainerStyle}>
            <ChangePasswordModal handleSubmitUpdatedPassword={handleSubmitUpdatedPassword} />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}

ChangePasswordCard.propTypes = {
  handleSubmitUpdatedPassword: PropTypes.func.isRequired,
}

export default ChangePasswordCard
